module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"save_transplant_details":"Save Transplant Details","or_details":"OR Details","cold_ischemic_time":"Cold Ischemic Time (CIT)"},"fr":{"save_transplant_details":"Sauvegarder les détails de la transplantation","or_details":"Détails de la salle d\u0027opération","cold_ischemic_time":"Temps d\u0027ischémie froide (TIF)"}}')
  delete Component.options._Ctor
}
